import React from 'react';
import { Grid, Typography } from 'e100-react-components';
import { Icon } from 'components';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';

export const NotSelectedStation = () => {
  const { formatMessage } = useIntl();

  const classes = useStyles();

  return (
    <Grid
      container
      justify="center"
      classes={{
        root: classes.container,
      }}
    >
      <Grid item xs={2}>
        <Icon kind="info" style={{ color: '#9BA4B0' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="subtitle1" color="textSecondary" align="center">
          <b>{formatMessage({ id: 'itEmptyForNow' })}</b>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary" align="center">
          {formatMessage({ id: 'AllSelectedStationOnRouteWillBeHere' })}
        </Typography>
      </Grid>
    </Grid>
  );
};
